import { supabase } from "../../lib/supabase";

export const THERA_TERMS_VERSION = "2026-09-18-v1";
export const THERA_PRIVACY_VERSION = "2026-09-18-v1";
export const THERA_CONTRIBUTION_VERSION = "2026-09-18-v1";

export type TheraAccessWithConsent = {
  firstNames: string;
  lastNames: string;
  age: number;
  country: string;
  city: string;
  email: string;
  password: string;
  termsAccepted: boolean;
  privacyAccepted: boolean;
  contributionAuthorized: boolean;
};

export type TheraContributionState = {
  termsAccepted: boolean;
  privacyAccepted: boolean;
  contributionAuthorized: boolean;
  termsVersion: string;
  privacyVersion: string;
  contributionVersion: string;
  acceptedAt: string | null;
  contributionUpdatedAt: string | null;
};

export async function requestAccessWithConsent(data: TheraAccessWithConsent) {
  if (!supabase) return { error: new Error("Supabase todavia no esta configurado.") };
  if (!data.termsAccepted || !data.privacyAccepted) {
    return { error: new Error("Debes aceptar los Terminos y la Politica de Privacidad para crear la cuenta.") };
  }

  return supabase.auth.signUp({
    email: data.email,
    password: data.password,
    options: {
      emailRedirectTo: `${window.location.origin}/`,
      data: {
        first_names: data.firstNames,
        last_names: data.lastNames,
        age: data.age,
        country: data.country,
        city: data.city,
        terms_accepted: true,
        privacy_accepted: true,
        contribution_authorized: data.contributionAuthorized,
        terms_version: THERA_TERMS_VERSION,
        privacy_version: THERA_PRIVACY_VERSION,
        contribution_version: THERA_CONTRIBUTION_VERSION,
      },
    },
  });
}

export async function getMyContributionState(): Promise<TheraContributionState | null> {
  if (!supabase) return null;
  const { data: authData, error: authError } = await supabase.auth.getUser();
  if (authError) throw authError;
  const user = authData.user;
  if (!user) return null;
  const { data, error } = await supabase
    .from("user_data_consents")
    .select("terms_accepted,privacy_accepted,contribution_authorized,terms_version,privacy_version,contribution_version,accepted_at,contribution_updated_at")
    .eq("user_id", user.id)
    .maybeSingle();
  if (error) throw error;
  if (!data) return null;
  return {
    termsAccepted: Boolean(data.terms_accepted),
    privacyAccepted: Boolean(data.privacy_accepted),
    contributionAuthorized: Boolean(data.contribution_authorized),
    termsVersion: String(data.terms_version ?? ""),
    privacyVersion: String(data.privacy_version ?? ""),
    contributionVersion: String(data.contribution_version ?? ""),
    acceptedAt: data.accepted_at ? String(data.accepted_at) : null,
    contributionUpdatedAt: data.contribution_updated_at ? String(data.contribution_updated_at) : null,
  };
}

export async function acceptCurrentLegalConsent() {
  if (!supabase) throw new Error("Supabase todavia no esta configurado.");
  const { data, error } = await supabase.rpc("accept_current_legal_consent");
  if (error) throw error;
  return Boolean(data);
}
export async function setMyContributionAuthorization(enabled: boolean) {
  if (!supabase) throw new Error("Supabase todavia no esta configurado.");
  const { data, error } = await supabase.rpc("set_data_contribution", { p_enabled: enabled });
  if (error) throw error;
  return Boolean(data);
}

export async function registerActivityFieldSurveyContribution(clientActivityId: string) {
  if (!supabase) return null;
  const { data, error } = await supabase.rpc("register_activity_field_survey", {
    p_client_activity_id: clientActivityId,
  });
  if (error) throw error;
  return typeof data === "string" ? data : null;
}
